<div class="grid">
  <ng-content></ng-content>
</div>
